module.exports = __webpack_public_path__ + "static/media/app-store-android.e51c6c8a.svg";